import { render } from "./BannerIndicatorItem.vue?vue&type=template&id=fe6178fc&scoped=true&ts=true"
import script from "./BannerIndicatorItem.vue?vue&type=script&lang=ts"
export * from "./BannerIndicatorItem.vue?vue&type=script&lang=ts"

import "./BannerIndicatorItem.vue?vue&type=style&index=0&id=fe6178fc&lang=scss&scoped=true"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe6178fc"]])

export default __exports__